<template>
    <div>
      <b-progress :value="this.step" :max="this.NoOfSteps" variant="info"></b-progress>
      <component :is="stepComponent"  @PageComplete="PageComplete" :DataPass='DataPass' :Type='Type' :ID='ID'/>
      <br/> 
      <b-row>
        <b-col><b-button variant="outline-dark" v-if="this.step>1" v-on:click="back">Back</b-button></b-col>
        <b-col> 
            <b-button variant="outline-info" v-if="this.stepComplete == false" v-on:click="next">Next</b-button>
            <b-button variant="outline-success" v-if="this.lastCompleted == true" v-on:click="finishWizard">Submit</b-button>
        </b-col>
      </b-row>
    

    
    </div>
  </template>
  
  <script>
  export default {
    props:['DataPass','Type','ID'],
    data(){
        return{
        NoOfSteps: 6,
        step: 1,
        stepComplete: true,
        lastCompleted: null,
        PassedValues: {
          General: {
              CreatedBy: "",
              CreatedOn: "",
              Location: "",
              ResponsibleDept: "",
              EscalationName: "",
              EscalationEmail: "",
              EscalationSeraph: ""
                    },
          HotWater: {
              OutletMin: "",
              HotWaterReturn: ""
                    },
          ColdWater: {
              OutletMax: "",
              SupplyTemp: ""
                    },
          Flow: {
              OutletFrequency: ""
                    },
          TMV: {
              TMVHot: "",
              TMVCold: "",
              MixedOut: ""
                    },
          Tanks: {
              ColdWaterMax: "",
              HotWaterMin: "",
              HotWaterMax: "",
              CombiMin: "",
              POUMin: "",
              POUMax: "",
              CalorifierOut: "",
              CalorifierReturn: ""
                    },
          CoolingTowers: {
              TowerTempMax: "",
              TowerTempMin: "",
              TowerFlow: ""
                    },
          Custom: {
              CustomHot: "",
              CustomCold: "",
              CustomFlow: ""
                    }
        },
      }
    },
    
    computed: {
      stepComponent() {
        this.step;
        return () => import(`@/components/SOCComponents/SOCScreen${this.step}.vue`);
      }
    },
    methods: {
      next() {
        this.stepComplete = true;
        if (this.step < this.NoOfSteps){
            this.step++;
        }
        else{
            return;
        }
        
      },
      back(){
        this.step--;
      },
      PageComplete(page,data){

        if(page  == 1){     
          this.PassedValues.General.CreatedBy = data.General.CreatedBy
          this.PassedValues.General.CreatedOn = data.General.CreatedOn
          this.PassedValues.General.Location = data.General.Location
          this.PassedValues.General.ResponsibleDept = data.General.ResponsibleDept
          this.PassedValues.General.EscalationName = data.General.EscalationName
          this.PassedValues.General.EscalationEmail = data.General.EscalationEmail
          this.PassedValues.General.EscalationSeraph = data.General.EscalationSeraph
   
          this.stepComplete = false;
        } else if (page == 2){
          this.PassedValues.HotWater.OutletMin = data.HotWater.OutletMin
          this.PassedValues.HotWater.HotWaterReturn = data.HotWater.HotWaterReturn
          this.PassedValues.ColdWater.OutletMax = data.ColdWater.OutletMax
          this.PassedValues.ColdWater.SupplyTemp = data.ColdWater.SupplyTemp
          this.PassedValues.Flow.OutletFrequency = data.Flow.OutletFrequency

          this.stepComplete = false;
        } else if (page == 3){
          this.PassedValues.TMV.TMVHot = data.TMV.TMVHot
          this.PassedValues.TMV.TMVCold = data.TMV.TMVCold
          this.PassedValues.TMV.MixedOut = data.TMV.MixedOut

          this.stepComplete = false;
        }else if (page == 4){
          this.PassedValues.Tanks.ColdWaterMax = data.Tanks.ColdWaterMax
          this.PassedValues.Tanks.HotWaterMin = data.Tanks.HotWaterMin
          this.PassedValues.Tanks.HotWaterMax = data.Tanks.HotWaterMax
          this.PassedValues.Tanks.CombiMin = data.Tanks.CombiMin
          this.PassedValues.Tanks.POUMin = data.Tanks.POUMin
          this.PassedValues.Tanks.POUMax = data.Tanks.POUMax
          this.PassedValues.Tanks.CalorifierOut = data.Tanks.CalorifierOut
          this.PassedValues.Tanks.CalorifierReturn = data.Tanks.CalorifierReturn

          this.stepComplete = false;
        } else if(page == 5){
          this.PassedValues.CoolingTowers.TowerTempMax = data.CoolingTowers.TowerTempMax
          this.PassedValues.CoolingTowers.TowerTempMin = data.CoolingTowers.TowerTempMin
          this.PassedValues.CoolingTowers.TowerFlow = data.CoolingTowers.TowerFlow

          this.stepComplete = false;
        } else if (page ==6){
          this.PassedValues.Custom.CustomHot = data.Custom.CustomHot
          this.PassedValues.Custom.CustomCold = data.Custom.CustomCold
          this.PassedValues.Custom.CustomFlow = data.Custom.CustomFlow

          this.stepComplete = false;
        } 
        if (page == this.NoOfSteps){
          this.stepComplete = true;
          this.lastCompleted = true;
        }
      },

      finishWizard(){
  
        let returnedType = this.Type
        let returnedID = this.ID

        this.$emit("WizardComplete",this.PassedValues,returnedType,returnedID);
      }
    }
  };
  </script>